import { render, staticRenderFns } from "./CustomerName.vue?vue&type=template&id=21f1f90e"
import script from "./CustomerName.vue?vue&type=script&lang=js"
export * from "./CustomerName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports